var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossArrowsIconSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crossArrowsIconSecondary_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.478 20.16.962-1.57a.798.798 0 0 0-.256-1.097.78.78 0 0 0-1.084.26l-.963 1.57c-1.745 2.847-4.234 4.482-6.839 4.482H.783a.788.788 0 0 0-.783.798c0 .441.353.798.783.798h3.522c3.163-.013 6.14-1.92 8.173-5.241Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.82 2.063 3.94 3.483a.66.66 0 0 1 .007 1.013l-3.948 3.483a.866.866 0 0 1-.577.211.866.866 0 0 1-.577-.21.656.656 0 0 1 0-1.013l2.56-2.26h-3.768c-2.693 0-5.268 1.47-7.072 4.04l-.61.871a.844.844 0 0 1-.69.34.908.908 0 0 1-.425-.105c-.385-.211-.505-.65-.266-.99l.61-.872c2.104-2.997 5.19-4.718 8.453-4.718h3.776l-2.561-2.26a.656.656 0 0 1 0-1.013.887.887 0 0 1 1.147 0Zm2.209 3.987v.012l.013-.012-.013-.011v.011Zm-2.717 23.096a.817.817 0 0 1-.568-.223.727.727 0 0 1 0-1.062s2.514-2.396 2.507-2.396h-3.584c-3.213 0-6.249-1.825-8.319-5.01l-5.89-9.045c-1.775-2.72-4.315-4.284-6.96-4.284h-3.7C.359 7.126 0 6.784 0 6.362S.353 5.6.797 5.6h3.708c3.213 0 6.249 1.819 8.319 5.003l5.889 9.046c1.776 2.725 4.316 4.29 6.96 4.29h3.598l-2.52-2.397a.73.73 0 0 1 0-1.074.825.825 0 0 1 1.129 0l3.885 3.688a.73.73 0 0 1 0 1.074l-3.885 3.694a.817.817 0 0 1-.568.224Zm2.755-4.45-.013-.013v.024l.013-.012Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crossArrowsIconSecondary_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 16 16)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossArrowsIconSecondary);
export default __webpack_public_path__ + "static/media/cross_arrows_icon_secondary.661513d9bbdf0ca33c812fbf16d648a4.svg";
export { ForwardRef as ReactComponent };